import React, { useState } from 'react'
import { SubmitButton, ErrorMessageBox, ga, Svg } from '../../application'
import { useMutation } from 'react-apollo-hooks'
import { textBuilder } from '../../resources'
import * as validator from '../../application/validator'
import styled from 'react-emotion'
import getText from '../strings'
import * as Mutations from '../mutations'
import { useAuth } from '../../authContext'

const Link = styled('a')`
  cursor:pointer;
  user-select: none;
`

const Flex = styled('div')`
  display: flex;
  align-items: flex-start;
  input {
    padding: 0 10px;
    margin-right: 10px;    
    height: 36px;    
  }
  >div {
    min-width: 200px;
    margin-right: 10px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    >div, .btn.btn-sm {
      min-width: unset;
      width: 100%;
      margin-right: 0;
    }
    input {
      width: 100%;      
    }
  }
`

const Info = styled('div')`
  background-color: #e7e3db; 
  margin-bottom: 20px;
  padding: 10px 10px 1px 10px;
  border-radius: 5px;  
  border: 0;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.1);
  color: #092a5e;  
  @media (max-width: 992px) {
    padding-bottom: 10px;
    padding-right: 10px;
    a {
      margin-top: 5px;
      display: block;
    }
  }
`

const Field = styled('div')`
`

export default ({ onBookingAdded }) => {
  const { profile } = useAuth()
  const [visible, setVisible] = useState(false)
  const [bookingNumber, setBookingNumber] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [validationError, setValidationError] = useState(null)
  const [error, setError] = useState(null)

  const addBooking = useMutation(Mutations.addBooking, {
    update: (proxy, mutationResult) => {
      if (!mutationResult.data.addBooking)
        setError(getText('errors', 'general'))
      else
        setVisible(false)

      setSubmitting(false)
      onBookingAdded()
    }
  })

  const handleToggle = () => {
    ga.buttonClick(`booking-add-toggle-${!visible}`)
    setVisible(!visible)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setError(null)
    if (validationError)
      return

    ga.buttonClick('booking-add')
    setSubmitting(true)
    addBooking({
      variables: {
        bookingNumber: bookingNumber
      }
    })
  }

  const onChange = (e) => {
    setBookingNumber(e.target.value)
  }

  const validate = (e) => {
    setValidationError(validator.required(e.target.value) || validator.atcomOrCrsBookingNumber(e.target.value))
  }

  return (
    <Info>
      <p>
        <Svg icon="message-info" />&nbsp;
        {textBuilder(
          getText('add', 'noBookingsInfo'),
          <Link onClick={handleToggle}>{getText('add', 'fetch')}</Link>
        )}
      </p>
      {visible &&
        <form onSubmit={handleSubmit}>
          <p>{getText('add', 'withSameEmail')}&nbsp;<strong>{profile.email}</strong></p>
          <Flex>
            <Field className='form-group'>
              <input
                className={`form-control ${validationError ? 'input-validation-error' : ''}`}
                id={`bookingNumber`}
                type='text'
                placeholder={getText('bookingNumber')}
                onChange={onChange}
                onBlur={validate}
              />
              {validationError && <span className='validation-message field-validation-error'>{validationError}</span>}
            </Field>
            <SubmitButton className="btn-sm" text={getText('add', 'getBooking')} submitting={submitting} />
          </Flex>
          {error && <ErrorMessageBox message={error} isError={true} />}
        </form>
      }
    </Info>
  )
}

